import {RedirectUrlComponent} from "./component/redirectUrlComponent";
import {RedirectParameterController} from "./component/redirectParameterComponent";
import {ColorService} from "./service/ColorService";
import {configureRedirectController} from "./route/configureRedirectsController";
import {ConfigurableRedirectService} from "../redirect_service/service/ConfigurableRedirectService";
import RedirectModuleConfiguration from "./RedirectModuleConfiguration";
import './route/configurable_redirect.scss';

RedirectModuleConfiguration
    .createNewModule()
    .component('redirectParameterComponent', {
            controller: ['$scope', RedirectParameterController],
            template: require('./component/redirect_url_parameter.html'),
            bindings: {
                urlParameter: '=',
                onUpdate: '&',
                onDelete: '&'
            }
        }
    )
    .component('redirectComponent', {
        controller: RedirectUrlComponent,
        template: require('./component/redirect_url_component.html'),
        bindings: {
            configurableUrl: '<'
        }
    })
    .controller('configureRedirectsController',
        ['$scope', 'redirects', '$mdDialog', 'LoaderStatusValue', 'ConfigurableRedirectService', configureRedirectController])
    .service('ColorService', ColorService);